import type { Cycle } from './subscription.types';

export const fmtDate = (ts: number) =>
  new Date(ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

export const cycleUnit = (cycle: Cycle) => (cycle === 'yearly' ? '/yr' : '/mo');

/**
 * A date with the time of day on it, for a deadline close enough that the day alone does not
 * settle it — "runs out Sep 16" is no help when the question is whether it is inside 48 hours.
 */
export const fmtDateTime = (ts: number) =>
  new Date(ts).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
